import { getNavigator } from "@faire/web--source/common/globals/getNavigator";
export var isFacebookBrowser = function() {
    var _getNavigator, _getNavigator1, _getNavigator2;
    return !!((_getNavigator = getNavigator()) === null || _getNavigator === void 0 ? void 0 : _getNavigator.userAgent.includes("FBAN")) || !!((_getNavigator1 = getNavigator()) === null || _getNavigator1 === void 0 ? void 0 : _getNavigator1.userAgent.includes("FBIOS")) || !!((_getNavigator2 = getNavigator()) === null || _getNavigator2 === void 0 ? void 0 : _getNavigator2.userAgent.includes("FB_IAB"));
};
var isInstagramBrowser = function() {
    var _getNavigator;
    return !!((_getNavigator = getNavigator()) === null || _getNavigator === void 0 ? void 0 : _getNavigator.userAgent.includes("Instagram"));
};
export var isSocialBrowser = function() {
    return isFacebookBrowser() || isInstagramBrowser();
};
